import { bookingsStrings, bookingsStringsCN } from '@data/bookings';
import type { PageMeta } from '@utils/pages';

export const meta: PageMeta = {
  title: bookingsStrings.title()['past_canceled'],
  titleCn: bookingsStringsCN.title()['past_canceled'],
  order: 7,
  staffOnly: true,
};
